// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--1NCWD","complaint_content":"dece2e673c--complaint_content--g4wwf","button":"dece2e673c--button--2RxuQ"};